import { render, staticRenderFns } from "./SwitchBig.vue?vue&type=template&id=b452e9d0&scoped=true&"
import script from "./SwitchBig.vue?vue&type=script&lang=js&"
export * from "./SwitchBig.vue?vue&type=script&lang=js&"
import style0 from "./SwitchBig.vue?vue&type=style&index=0&id=b452e9d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b452e9d0",
  null
  
)

export default component.exports